// extracted by mini-css-extract-plugin
export default {"total":"Notes_total__QEJMP","list":"Notes_list__HpRGM","blankDiv":"Notes_blankDiv__65Oyd"};